import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { SelectItem } from 'primeng/api';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-performance-overview',
  templateUrl: './performance-overview.component.html',
  styleUrls: ['./performance-overview.component.scss'],
  animations: fuseAnimations
})
export class PerformanceOverviewComponent implements OnInit {

  reportingToOptions = [];
  deptOptions: SelectItem[];
  employeeList = [];
  profileId = '';
  optionList = [
    { label: 'Poor', value: 'Poor', rating: 1 },
    { label: 'Fair', value: 'Fair', rating: 2 },
    { label: 'Satisfactory', value: 'Satisfactory', rating: 3 },
    { label: 'Good', value: 'Good', rating: 4 },
    { label: 'Excellent', value: 'Excellent', rating: 5 }
  ];
  isEdit = false;
  totalRatings = 0;
  @ViewChild(FormGroupDirective, { static: false }) formGroupDirective: FormGroupDirective;
  jobKnowledge = 0;
  workQuality = 0;
  initiative = 0;
  communication = 0;
  dependability = 0;
  maxDate = new Date();
  reportingTo = '';
  reviewList = [];
  tenantId='';
  performanceCols = [
    { field: 'position', header: 'Position' },
    { field: 'userName', header: 'User Name' },
    { field: 'overallRatings', header: 'Overall Ratings' },
    { field: 'reviewStartDate', header: 'Review Start Date' },
    { field: 'reviewEndDate', header: 'Review End Date' },
    { field: 'department', header: 'Department' },
    { field: 'reportingTo', header: 'Reporting To' },
    { field: 'createdBy', header: 'Created By' },
    { field: 'yearOfExperience', header: 'Year Of Experience' },
    { field: 'action', header: 'Action' },
  ];
  reviewCount = 0;
  empRole = '';
  filteredOptions: Observable<string[]>;
  myControl = new FormControl();
  selectedProfileId = '';
  @ViewChild('confirmationPopup', { static: false }) confirmationPopup: TemplateRef<any>;
  reviewId = '';

  constructor(
    private parseService: ParseService,
    private storageConfiguration: StorageConfiguration,
    public dialog: MatDialog,
    private router: Router,
    private queryInterface: QueryInterface,
    private getReportingToService: GetReportingToService,
    private hardCodedValues: HardCodedValues,
    private toastr: ToastrService
  ) {
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
  }

  async ngOnInit() {
    await this.getPerformanceReviewList();
    this.getReportingTo();
    this.getDepartment();
  }

  async getReportingTo() {
    await this.getReportingToService.getReportingTo().then(res => {
      this.reportingToOptions = res;
    });
  }

  async getDepartment() {
    await this.getReportingToService.getDepartment().then(res => {
      this.deptOptions = res;
    });
  }

  async getPerformanceReviewList() {
    let profileInstance = this.parseService.instance.Object.extend('PerformanceReview');
    let query = new this.parseService.instance.Query(profileInstance);
    query.limit(10000);
    query.include('role');
    query.include('department');
    query.include('reportingTo');
    query.include('profileId');
    query.descending('overallRatings');
    query.equalTo('tenantId',this.tenantId)
    if (this.empRole == 'Leader') {
      query.equalTo('createdBy', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    }
    let reviewList = await query.find();
    this.reviewList = [];
    let i = 0;
    for (const element of reviewList) {

      let userImage = '';
      var userObj = element.get('profileId').get('profileImageInfo');
      if (this.isEmpty(userObj)) {
        userImage = this.hardCodedValues.defaultProfileImg;
      } else {
        userImage = element.get('profileId').get('profileImageInfo').url
      }

      let reporterImage = '';
      var reporterObj = element.get('reportingTo').get('profileImageInfo');
      if (this.isEmpty(reporterObj)) {
        reporterImage = this.hardCodedValues.defaultProfileImg;
      } else {
        reporterImage = element.get('reportingTo').get('profileImageInfo').url
      }

      let experienceInYear = (element.get('profileId').get('officialInfo').experience != undefined) && (element.get('profileId').get('officialInfo').experience.year != undefined)
        && (element.get('profileId').get('officialInfo').experience.year != '') ? element.get('profileId').get('officialInfo').experience.year : 0;

      let experienceInMonth = (element.get('profileId').get('officialInfo').experience != undefined) && (element.get('profileId').get('officialInfo').experience.month != undefined) &&
        (element.get('profileId').get('officialInfo').experience.month != '') ? element.get('profileId').get('officialInfo').experience.month : 0;

      let totalExperience = (experienceInYear + '.' + experienceInMonth);

      i = i + 1;
      const tenantDepartment = await this.queryInterface.getDepartmentUser(element.get('department').id);
      this.reviewList.push({
        id: element.id,
        position: i,
        userName: element.get('profileId').get('firstName') + ' ' + element.get('profileId').get('lastName'),
        userImage: userImage,
        profileId: element.get('profileId').id,
        overallRatings: element.get('overallRatings'),
        reportingTo: element.get('reportingTo').get('firstName') + ' ' + element.get('reportingTo').get('lastName'),
        // department: element.get('department').get('name'),
        department: tenantDepartment.get('displayName'),
        reviewStartDate: element.get('reviewStartDate'),
        reviewEndDate: element.get('reviewEndDate'),
        reporter: element.get('reportingTo').id,
        reporterImage: reporterImage,
        departmentId: element.get('department').id,
        yearOfExperience: totalExperience
      });
    }
    this.reviewCount = this.reviewList.length;
  }
  // tenantId(arg0: string, tenantId: any) {
  //   throw new Error('Method not implemented.');
  // }

  isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }

  toggle() {
    this.router.navigate(['/create-review']);
  }

  editReview(id) {
    this.router.navigate(['/create-review', { id: id, isReview: false }]);
  }

  viewReview(id) {
    this.router.navigate(['/create-review', { id: id, isReview: true }]);
  }

  close() {
    this.dialog.closeAll();
  }

  delete(id) {
    this.reviewId = id;
    this.dialog.open(this.confirmationPopup, {
      width: '400px'
    });
  }

  async deleteReview() {
    const reviewInstance = this.parseService.instance.Object.extend('PerformanceReview');
    const query = new this.parseService.instance.Query(reviewInstance);
    query.equalTo('objectId', this.reviewId);
    const results = await query.find();
    let result = results[0];
    let data = await result.destroy();
    this.dialog.closeAll();
    this.getPerformanceReviewList();
    this.toastr.success('Review deleted successfully');
  }


}
